<template>
    <div class="center w-1/3" name="mjHome">
        <a :href="[url ? url : '#']" class="inline-block">
            <span v-if="subtitle || title" class="primaryLogo font-anonymouse block tracking-spc2 leading-none text-dark_gray text-size4 font-semibold">
                {{title}}
                <span v-if="subtitle" class="block text-size5 mt-2 font-normal leading-none">{{subtitle}}</span>
            </span>
        </a>
    </div>
</template>
<script>
    export default {
        name: "Logo",
        props: ['title', 'subtitle', 'url']
    }
</script>

<style scoped>

</style>